import "../../shared/assetDetailsButtons.css";
import PrintQRButton from "../../shared/PrintQRButton";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AuditassetDetails.css";
import { Link, useNavigate } from "react-router-dom";
import { downloadQRLabel } from "../../../utils/qrLabelPrint";
import useAutoRefresh from "../../../hooks/useAutoRefresh";
import useDebouncedValue from "../../../hooks/useDebouncedValue";
import AssetPagination from "../../shared/AssetPagination";

const AuditAssetDetails = () => {
  const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [currentUser, setCurrentUser] = useState(null);
  const [categories, setCategories] = useState([]);
   const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [selectedAssetId, setSelectedAssetId] = useState(null);
    const [discardReason, setDiscardReason] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });
  const serverSearch = useDebouncedValue([searchQuery, searchQuery1, searchQuery2].filter(Boolean).join(" "));
  useEffect(() => setPage(1), [serverSearch]);

  // State for editing
  const [editingAsset, setEditingAsset] = useState(null);

  const openDiscardModal = (id) => {
    setSelectedAssetId(id);
    setShowDiscardModal(true);
  };

  useEffect(() => {
    fetchAssets();
    fetchCategories();
  }, [page, serverSearch]);

  //Asset department Filter
  const fetchCategories = async () => {
    const response = await axios.get(
      "/api/categories/getCategory",
    );
    setCategories(response.data);
  };

  const fetchAssets = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")); // Get logged-in user details

    if (!currentUser || !currentUser.username) {
      console.error("User data not found or username missing");
      return;
    }

    try {
      // Fetch all registered users
      const userResponse = await axios.get(
        "/api/users/getallUsers",
      );
      const allUsers = userResponse.data;

      // Find the user that matches the current username
      const userData = allUsers.find(
        (user) => user.username === currentUser.username,
      );

      if (!userData || !userData.companyName) {
        console.error("User company details not found");
        return;
      }

      setCurrentUser(userData);

      if (!userData || !userData.companyName) {
        console.error("User company details not found");
        return;
      }

      // Fetch asset details
      axios
        .get(
          "/api/AssetRegisterDetails/getAssetDetails",
          { params: { paginated: true, page, limit: 100, search: serverSearch } },
        )
        .then((response) => {
          setAssetRegisterDetails(response.data.assets);
          setPagination(response.data.pagination);
        });
    } catch (error) {
      console.error("Error fetching asset details or user data:", error);
    }
  };

  useAutoRefresh(fetchAssets);

  const navigate = useNavigate();

  const handleTransferClick = (asset) => {
    navigate("/AuditTransfer", { state: { asset } }); // Pass asset data via state
  };

  // Update an existing asset
  const handleUpdateAsset = (id, updatedAsset) => {
    axios
      .put(
        `/api/AssetRegisterDetails/updateAsset/${id}`,
        /* `/api/AssetRegisterDetails/updateAsset/${id}`,*/
        updatedAsset,
      )
      .then(() => {
        fetchAssets();
        setEditingAsset(null);
      })
      .catch((error) => console.error("Error updating asset:", error));
  };

  // Delete an asset
  const confirmDiscard = async () => {
    if (!discardReason.trim()) {
      alert("Discard reason is required!");
      return;
    }

    const assetToDelete = assetRegisterDetails.find(
      (asset) => asset._id === selectedAssetId,
    );

    try {
      const assetWithReason = {
        ...assetToDelete,
        discardReason: discardReason,
        discardedDate: new Date(),
      };

      await axios.post(
        "/api/DeletedAssets/add", /*"/api/DeletedAssets/add",*/
        assetWithReason,
      );

      await axios.delete(
        `/api/AssetRegisterDetails/deleteAsset/${selectedAssetId}`
        /*`/api/AssetRegisterDetails/deleteAsset/${selectedAssetId}`,*/
      );

      fetchAssets();
      setShowDiscardModal(false);
      setDiscardReason("");
      alert("Asset discarded successfully!");
    } catch (error) {
      console.error("Error discarding asset:", error);
    }
  };


  const handleDownloadQR = async (asset) => {
    try {
      await downloadQRLabel(asset);
    } catch (error) {
      window.alert(error.message || "Unable to download the QR label.");
    }
  };

  // Filter logic
  const filteredAssets = assetRegisterDetails.filter((asset) => {
    const queryMatch = (query, asset) =>
      (asset.name?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.company?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.department?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.category?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.type?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.assetName?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.assetUserName?.toLowerCase() || "").includes(
        query.toLowerCase(),
      ) ||
      (asset.assetModel?.toLowerCase() || "").includes(query.toLowerCase()) ||
       (asset.assetUpdateDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetTransferDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.serialNumber?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.trackingId?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.subComponent?.toLowerCase() || "").includes(
        query.toLowerCase(),
      ) || (asset.conditionType?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.invoiceDetails?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.specialNote?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.warranty?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.supplierName?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.invoiceNumber?.toLowerCase() || "").includes(query.toLowerCase()) ||
      (asset.purchaseDate?.toLowerCase() || "").includes(query.toLowerCase());

    return [searchQuery, searchQuery1, searchQuery2].every(
      (query) => !query || queryMatch(query, asset),
    );
  });

  const canUserModifyAsset = (asset) => {
    if (!currentUser || !categories.length) return false;

    const categoryData = categories.find(
      (cat) => cat.category === asset.category && cat.types === asset.type,
    );

    if (!categoryData) return false;

    return categoryData.departments.includes(currentUser.department);
  };

  return (
    <div className="row asset-details-buttons">
      <div className="col-md-14">
        <h1 className="assethead">Asset Details</h1>
        <p>
          <Link to="/AuditDashBoard">DashBoard</Link> /{" "}
          <Link to="/AuditAsset">Asset Details</Link>
        </p>

        {/* Search Inputs */}
        <div className="row">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search by another parameter..."
              value={searchQuery1}
              onChange={(e) => setSearchQuery1(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search by another parameter..."
              value={searchQuery2}
              onChange={(e) => setSearchQuery2(e.target.value)}
            />
          </div>
        </div>
        {/* Asset Table */}
        <table className="table table-bordered table-light custom_table">
          <thead className="thead-dark">
            <tr>
              <th>Registered Name</th>
              <th>Company</th>
              <th>Department</th>
              <th>Category</th>
              <th>Condition Type</th>
              <th>Type</th>
              <th>Asset Name</th>
              <th>EPF No & Recipient Name</th>
              <th>Model</th>
              <th>Register Date</th>
              <th>Serial Number</th>
              <th>Tracking ID</th>
              <th>Price (Rs)</th>
              <th>Special Note</th>
              <th>Components</th>
              <th>Asset Image</th>
              <th>Invoice Image</th>
              <th>Warranty</th>
              <th>Supplier Name</th>
              <th>Invoice Number</th>
              <th>Purchase Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssets.length > 0 ? (
              filteredAssets.map((asset) => (
                <tr key={asset._id}>
                  {editingAsset === asset._id ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={asset.name}
                          onChange={(e) =>
                            setEditingAsset({ ...asset, name: e.target.value })
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={asset.company}
                          onChange={(e) =>
                            setEditingAsset({
                              ...asset,
                              company: e.target.value,
                            })
                          }
                        />
                      </td>
                      <td colSpan="10">
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            handleUpdateAsset(asset._id, editingAsset)
                          }
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={() => setEditingAsset(null)}
                        >
                          Cancel
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{asset.name}</td>
                      <td>{asset.company}</td>
                      <td>{asset.department}</td>
                      <td>{asset.category}</td>
                      <td>{asset.conditionType}</td>
                      <td>{asset.type}</td>
                      <td>{asset.assetName}</td>
                      <td>{asset.assetUserName}</td>
                      <td>{asset.assetModel}</td>
                      <td>
                        {asset.isTransfer
                          ? asset.assetTransferDate
                          : asset.assetUpdateDate}
                      </td>
                      <td>{asset.serialNumber}</td>
                      <td>{asset.trackingId}</td>
                      <td>{asset.assetprice}</td>
                      <td>{asset.specialNote}</td>
                       <td>{asset.subComponent}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                      <td>{asset.warranty}</td>
                      <td>{asset.supplierName}</td>
                      <td>{asset.invoiceDetails}</td>
                      <td>{asset.purchaseDate}</td>
                      <td className="d-flex gap-2">
                        {currentUser &&
                          asset.department === currentUser.department &&
                          canUserModifyAsset(asset) && (
                            <>
                              <button
                                className="btn btn-primary1"
                                onClick={() => handleTransferClick(asset)}
                              >
                                Transfer
                              </button>

                              <button
                          className="btn btn-danger2"
                          onClick={() => openDiscardModal(asset._id)}
                        >
                          Discard
                        </button>
                            </>
                          )}

                        <button
                          className="btn btn-success3"
                          onClick={() => handleDownloadQR(asset)}
                        >
                          QR <i className="fas fa-download"></i>
                        </button>
                        <PrintQRButton asset={asset} />
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="text-center">
                  No matching asset data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <AssetPagination page={pagination.page || page} totalPages={pagination.totalPages} total={pagination.total} onPageChange={setPage} />
      </div>
       {showDiscardModal && (
        <div className="discard-modal-overlay">
          <div className="discard-modal">
            <h3>Discard Asset</h3>
            <p>Please provide a reason for discarding this asset.</p>

            <textarea
              placeholder="Enter discard reason..."
              value={discardReason}
              onChange={(e) => setDiscardReason(e.target.value)}
            />

            <div className="modal-buttons">
              <button
                className="cancel-btn"
                onClick={() => setShowDiscardModal(false)}
              >
                Cancel
              </button>
              <button className="confirm-btn" onClick={confirmDiscard}>
                Confirm Discard
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditAssetDetails;
